import React, { useEffect, useState } from 'react';
import { alertError, alertSuccess } from '../../utils/logger';
import { useHistory } from 'react-router-dom';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { changeEventsUrl, countAdmins } from '../../api/user'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { therapistIsVerified } from '../../utils/auth';
import { Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap';
import { Button, TextField } from '@material-ui/core';
import { getLanguages } from '../../api/language';
import { getCredentials } from '../../api/auth';
import { authActions } from '../modules/Auth/_redux/authActions';
import { getInitUrlCalendar } from '../../api/calendar';

export function DashboardPage() {
	const user = useSelector((store) => store.authentication?.user, shallowEqual)
	const [data, setData] = useState([]);
	const [isVerified, setIsVerified] = useState(true);
	const [therapist, setTherapist] = useState(user);
    const history = useHistory()
	const dispatch = useDispatch()

	async function fetchUser() { //POR SI SE HA ACTUALIZADO EL USUARIO ACTUAL
		try {
			const response = await getCredentials()
			if (response)
				dispatch(authActions.loginActionSuccess(response?.data))
				const languages = await getLanguages();
				if (languages?.data) {
					dispatch(authActions.getLanguagesSuccess(languages?.data));
				}
		} catch (error) {
			dispatch(authActions.logoutAction())
		}
	}

	useEffect(() => {
		async function fetchData() {
			try {
				const admins = await countAdmins()

				setData({
					numAdmins: admins.data
				})
			} catch (err) {
				alertError({ error: err, customMessage: 'Could not get statistics.'})
			}
		}
		fetchData();
		fetchUser();
	}, []);

	useEffect(() => {
		if (user) {
			setTherapist(user);
		   	setIsVerified(therapistIsVerified(user));
		}
	}, [user])

	useEffect(() => {
		console.log(therapist);
	}, [therapist])

	function text(fontSize, text, bold) {
		if (bold) return (<strong> <p style={{fontSize}}>{text}</p> </strong>)
		return (<p style={{fontSize}}>{text}</p>)
	}

	const handleChange = (element) => (event) => {
		setTherapist({ ...therapist, [element]: event.target.value})
	}

	const textS = 16, titleS = 24;
	if (!isVerified)
	return (<>
			<div className='col justify-content-center'>
				{text(titleS, `Bienvenido/a al equipo del Método M.E.S., ${therapist?.fullName}!`, true)}
				<br />
				{text(textS, `Gracias por formar parte de este camino de acompañamiento y sanación.`)}
				{text(textS, `Antes de empezar a utilizar la plataforma, necesitamos que completes unos sencillos pasos para poder coordinar las sesiones de forma clara y fluida.`)}
				<br />
				{text(textS, `Primeros pasos`, true)}
				<br />
				{text(textS, `Inicia sesión con Google - ${therapist?.googleTokens ? '✓': 'X'}`, true)}
				{/* {text(textS, `Accede a la plataforma utilizando tu cuenta de Google. Será la misma cuenta que utilizarás para gestionar tus citas.`)} */}
				
				<div style={{ display: 'flex', alignItems: 'center', gap: 12, }}>
					{text(textS, `Accede a la plataforma utilizando tu cuenta de Google. Será la misma cuenta que utilizarás para gestionar tus citas.`)}
					{ !user?.googleTokens && (
						<Button
							onClick={() => {
								history.push("/calendar?refresh=true")
							}}
							variant="outlined"
							color="primary"
							style={{ marginTop: -5, height: 30, marginRight: 200}}
						>
							Inicia sesión con google
						</Button>
					)}
				</div>

				<br />
				{text(textS, `Crea tu agenda de citas en Google Calendar - ${user?.eventsUrl ? '✓': 'X'}`, true)}
				{text(textS, `Entra en Google Calendar con esa misma cuenta de Gmail y crea una agenda destinada a tus sesiones (página de reserva).`)}
				{text(textS, `Una vez creada, copia el enlace de esa agenda y pégalo en el apartado correspondiente dentro de la plataforma.`)}
				{text(textS, `Después, guarda los cambios para que quede actualizada.`)}
				<Row>
					<Col sm={10}>
						<TextField
							id={`eventsUrl`}
							label="Url citas"
							value={therapist?.eventsUrl}
							onChange={handleChange("eventsUrl")}
							InputLabelProps={{
								shrink: true
							}}
							margin="normal"
							variant="outlined"
							required
						/>
					</Col>
					<Col>
					<Button
						onClick={() => {
							changeEventsUrl(user?._id, therapist?.eventsUrl)
								.then((res) => {
									alertSuccess({ message: "La url ha sido cambiada con éxito."});
									fetchUser();
								})
								.catch((error) => {
									alertError({ error, message: "Error cambiando la url de citas."})
								})
						}}
						variant="outlined"
						color="primary"
						style={{ marginTop: 18, height: 50}}
					>
						Actualizar url
					</Button>
					</Col>
				</Row>
				<br />
				{text(textS, `Acepta la invitación al calendario compartido - ${therapist?.calendarId ? '✓': 'X'}`, true)}
				{text(textS, `Recibirás un correo de Google Calendar con una invitación al calendario compartido del Método M.E.S.`)}
				{text(textS, `Es importante que la aceptes para que las citas puedan coordinarse correctamente.`)}
				{text(textS, `Si no has recibido este correo, puedes contactar con nostros desde enlace@gmail.com y te lo volveremos a enviar.`)}
			</div>
	</>)

	return (
		<>
			<div className='row justify-content-center'>
				<div className='col-12 col-md-4 text-center my-2' role='button' onClick={() => history.push('/admins')}>
					<div className='card'>
						<div className='card-body'>
							<h5 className='card-title'><AssignmentIndIcon/>  Administradores</h5>
							<div className='contentDash'>{data.numAdmins}</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
